import React from 'react'
import { Box, Container, Typography } from "@mui/material";
const Packages = ()=>{
    return(
        <Container 
            sx={{
                height:"auto",
                // backgroundColor: "yellow",
                padding: {xs:"20px 20px",md:"50px 40px",lg:"50px 0px"},
                display: "flex",
                flexDirection: "column"
            }}
        >
            <Box
                color="#ffffff"
            >
                    <Typography
                        variant="h3"
                        textAlign="center"
                        gutterBottom
                        sx={{
                            fontSize: {xs:"18px",sm:"28px",md:"34px",lg:"48px"},
                            fontWeight: "700",
                            width:"100%",
                            textTransform: "uppercase"
                            // backgroundColor: "red",
                        }}
                    >Subscribtion Plans</Typography>
                    <Typography
                        gutterBottom
                        variant="subtitle2"
                        component="p"
                        fontFamily="Times New Roman"
                        textAlign="center"
                        sx={{
                            fontSize: {xs:"14px",md:"20px"},
                            lineHeight: {xs:"18px",sm:"26px",md:"28px"},
                            pl:{md:"20px"}
                        }}
                    >
                        Choose the best plan for your test preparation needs with Sat App.
                    </Typography>
                </Box>
        </Container>
    );
}
export default Packages;